import { requestApi } from "~/api/requestApi";
import type { TUser } from "../type/TUser";

export async function apiUserGet(id: number) {
  const data = await requestApi({
    endpoint: `users/${id}`,
    method: "get",
  });

  return data as TUser;
}
